module.exports = __webpack_public_path__ + "img/event-atelier-mensuel-edition-speciale.1a0da26.jpg";